import React, { useEffect } from "react";
import BrandingHeader from "../components/BrandingHeader";
import { useAuth } from "../context/AuthContext";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import { XIcon } from "@heroicons/react/outline";
import { Redirect, useHistory } from "react-router-dom";

function EmailVerification() {
  const { currentUser } = useAuth();
  const { emailVerification } = useAuth();
  const history = useHistory();

  let temp = JSON.parse(sessionStorage.getItem("isRegistered"));

  useEffect(() => {
    if (currentUser) {
      if (currentUser.emailVerified && temp.registered === false) {
        history.push("/member/setup");
      } else if (currentUser.emailVerified && temp.registered) {
        history.push("/member/dashboard");
      } else if (!currentUser.emailVerified) {
        history.push("/member/verify-email");
        emailVerification();
      }
    } else {
      history.push("/signup");
    }
  }, [
    currentUser,
    currentUser.emailVerified,
    currentUser.displayName,
    history,
    emailVerification,
    temp.registered,
  ]);

  function resendEmail() {
    emailVerification();
    setIsOpen(true);
  }

  let [isOpen, setIsOpen] = useState(true);

  function closeModal() {
    setIsOpen(false);
  }

  return currentUser ? (
    <>
      <BrandingHeader />
      <div class="container px-5 py-16 sm:py-24 mx-auto flex flex-wrap flex-col">
        <img
          class="w-20 h-20 block mx-auto mb-10 object-cover object-center rounded"
          alt="hero"
          src="https://image.flaticon.com/icons/png/512/3253/3253724.png"
        />
        <div class="flex flex-col text-center w-full">
          <h1 class="text-3xl font-semibold title-font mb-4 text-gray-900">
            Verify your email
          </h1>
          <p class="md:w-1/3 lg:w-1/3 mx-auto leading-relaxed text-base">
            To keep a trusted and safe community, we’ve sent an email to{" "}
            <span className="text-blue-700">{currentUser.email}</span> for
            verification, and you’ll only do this once.
          </p>
          <p className="mt-4">
            Did not receive?{" "}
            <button
              onClick={resendEmail}
              className="border-none text-blue-700 underline focus:outline-none"
            >
              Resend email
            </button>
          </p>
          <p class="md:w-1/3 lg:w-1/3 mx-auto font-semibold leading-relaxed text-base mt-4">
            Please refresh this page if you have verified your email
          </p>
        </div>
      </div>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-10 overflow-y-auto"
          onClose={closeModal}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>
            <span
              className="inline-block relative align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block flex justify-between absolute right-6  bottom-0  max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                <div className="flex items-center">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-6 w-6 bg-green-400 rounded-full"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="white"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <div>
                    <Dialog.Title
                      as="h3"
                      className="text-sm font-base text-gray-900 ml-2 mr-6"
                    >
                      Verification email sent
                    </Dialog.Title>
                  </div>
                </div>
                <div>
                  <button
                    type="button"
                    className="flex absolute text-black rounded-md focus:outline-none"
                    onClick={closeModal}
                  >
                    <span className="sr-only">Dismiss</span>
                    <XIcon
                      className="h-5 w-6 text-gray-400"
                      aria-hidden="true"
                    />
                  </button>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  ) : (
    <Redirect to="/signup" />
  );
}

export default EmailVerification;
